const PARENT_ELEMENT = carousel_settings && carousel_settings.parent_element_id ? document.getElementById(carousel_settings.parent_element_id) : document;
const TIMEOUT = carousel_settings && typeof carousel_settings.carousel_timeout !== "undefined" ? carousel_settings.carousel_timeout : 8000;//8 seconds
const CAROUSEL_DISPLAY = carousel_settings && carousel_settings.display ? carousel_settings.display : 'block';

const CLASS_NAME = "carousel__item";
const CAROUSEL_ITEMS = PARENT_ELEMENT.getElementsByClassName(CLASS_NAME);

let currentSlideIndex = 0;

function runCarousel() {
  if (TIMEOUT > 0) {
    setInterval(() => {
      //If elements were found we start to move
      if (!CAROUSEL_ITEMS.length) return;
      moveCarouselToRight();
    }, TIMEOUT); // Change image every 8 seconds
  }
}

function jumpToSlide(slide) {
  _hideElement(CAROUSEL_ITEMS[currentSlideIndex]);
  currentSlideIndex = slide;

  _showElement(CAROUSEL_ITEMS[currentSlideIndex]);
}

function moveCarouselToRight() {
  _hideElement(CAROUSEL_ITEMS[currentSlideIndex]);
  currentSlideIndex++;

  if (currentSlideIndex === CAROUSEL_ITEMS.length) {
    currentSlideIndex = 0;
  }
  _showElement(CAROUSEL_ITEMS[currentSlideIndex]);
}

function moveCarouselToLeft() {
  _hideElement(CAROUSEL_ITEMS[currentSlideIndex]);
  currentSlideIndex--;

  if (currentSlideIndex < 0) {
    currentSlideIndex = CAROUSEL_ITEMS.length - 1;
  }
  _showElement(CAROUSEL_ITEMS[currentSlideIndex]);
}

function _hideElement(element) {
  element.style.display = "none";
}

function _showElement(element) {
  element.style.display = CAROUSEL_DISPLAY;
}

//function that runs carousel
runCarousel();